
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.751 12h-11a.75.75 0 00-.75.75v.767a8.725 8.725 0 01-.92 3.898.75.75 0 00.67 1.085h13a.75.75 0 00.67-1.085 8.725 8.725 0 01-.92-3.899v-.766a.75.75 0 00-.75-.75zm-10.25 1.499H15l.007.383c.035.974.209 1.935.515 2.856l.091.261H4.886l.093-.26c.301-.907.475-1.853.514-2.81l.007-.43z"}}),_c('path',{attrs:{"d":"M10.455 2.008L10.251 2a2.75 2.75 0 00-2.742 2.546l-.008.176c0 .9.072 1.771.214 2.632l.092.503c.009.044 0 .078-.02.103a.11.11 0 01-.085.04H5.751a2.75 2.75 0 00-2.75 2.75v1.5c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-1.5A2.75 2.75 0 0014.751 8H12.8a.11.11 0 01-.11-.117l.01-.06c.163-.81.264-1.678.292-2.55l.009-.51a2.753 2.753 0 00-2.546-2.755zM10.251 3.5l.122.005c.621.046 1.128.59 1.128 1.245l-.008.486a14.402 14.402 0 01-.271 2.34l-.023.154c-.034.457.095.863.356 1.18.306.374.763.59 1.245.59h1.951l.128.006A1.25 1.25 0 0116 10.75V12H4.5v-1.25c0-.69.56-1.25 1.25-1.25h1.951A1.61 1.61 0 009.28 7.575l-.087-.478a14.407 14.407 0 01-.192-2.347l.005-.122c.046-.621.59-1.128 1.245-1.128zm3.5 11a.75.75 0 01.743.648l.007.102v2.5a.75.75 0 01-1.493.102L13 17.75v-2.5a.75.75 0 01.75-.75zm-2 .5a.75.75 0 01.743.648l.007.102v2a.75.75 0 01-1.493.102L11 17.75v-2a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    